import { render } from "./OverviewField.vue?vue&type=template&id=6ed643d6&scoped=true"
import script from "./OverviewField.vue?vue&type=script&lang=js"
export * from "./OverviewField.vue?vue&type=script&lang=js"

import "./OverviewField.vue?vue&type=style&index=0&id=6ed643d6&lang=scss"
import "./OverviewField.vue?vue&type=style&index=1&id=6ed643d6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed643d6"],['__file',"src/scripts/view/review/components/OverviewField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ed643d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ed643d6', __exports__)) {
    api.reload('6ed643d6', __exports__)
  }
  
  module.hot.accept("./OverviewField.vue?vue&type=template&id=6ed643d6&scoped=true", () => {
    api.rerender('6ed643d6', render)
  })

}


export default __exports__